export const siteInfo = {
  name: "独家爆料",
  shortName: "爆料前线",
  tagline: "最新第一手进展，持续追踪",
  slogan: "追踪事件反转与后续，关键信息首发直达",
  description:
    "独家爆料专注热点事件的第一手进展，把零散消息整理成清晰的事件时间线，标注首发、更新、反转与后续四类节点。",
  contactEmail: "tips@baoliaoqianxian.example.com",
  workingHours: "编辑值守：每日 08:00 - 24:00（节假日不间断）",
  icp: "内容服务提供者：独家爆料编辑部",
};

export const siteStats = [
  { value: "1260", unit: "条", label: "在跟事件时间线" },
  { value: "48", unit: "万", label: "条已归集爆料线索" },
  { value: "4", unit: "类", label: "节点标注体系" },
  { value: "7", unit: "×24", label: "不间断更新值守" },
];

export const contentPrinciples = [
  {
    icon: "ri-time-line",
    title: "时间线优先",
    desc: "每一条爆料都标注发生时间与节点类型，先还原顺序，再讨论是非。",
  },
  {
    icon: "ri-links-line",
    title: "来源可回溯",
    desc: "保留原始表述与后续变化，不删除已更正的内容，方便读者自行比对。",
  },
  {
    icon: "ri-contrast-drop-line",
    title: "多方并列",
    desc: "当事各方说法同时呈现，标注分歧点，而不是只保留一方叙事。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续回访",
    desc: "事件降温后仍会回访关键节点，把后续进展补回同一条时间线。",
  },
];

export const faqs = [
  {
    question: "「独家爆料」上的事件信息是怎么来的？",
    answer:
      "我们主要归集读者投递的线索、当事方的公开表述以及可核查的第三方材料。每一条信息都会标注出现时间与节点类型（首发、更新、反转、后续），并在页面底部说明来源，方便你自行判断可信度。",
  },
  {
    question: "事件时间线里的「反转」和「后续」有什么区别？",
    answer:
      "「反转」指出现了与先前主要说法不一致、并足以改变理解方向的新信息；「后续」指事件处理后段的进展，比如监管结果、复检公示、退款方案落地等。两者都会保留在原时间线上，不会覆盖旧内容。",
  },
  {
    question: "如果我发现了与现有时间线不符的信息怎么办？",
    answer:
      "可以通过本页的联系方式或线索投递表单提交。请尽量附上时间、出处与原始截图。我们在核实后会把新节点追加到对应事件的时间线，并标注更正时间。",
  },
  {
    question: "为什么有些事件更新到一半就不再更新了？",
    answer:
      "通常有两种情况：一是当事各方均无新增公开表述；二是关键结论依赖尚未公布的官方结果。这类事件会标记为「待后续」，一旦有新进展会重新回到更新队列。",
  },
  {
    question: "网站上的热度数据代表什么？",
    answer:
      "热度综合了话题讨论量、时间线更新频次与读者停留时长，只用来反映关注程度，不代表我们对事件真实性的判断。任何一条时间线的可信度，仍应以来源与可核查材料为准。",
  },
  {
    question: "可以转载时间线内容吗？",
    answer:
      "欢迎在注明来源与时间线版本日期的前提下引用。如果你要在自己的平台上整理同一条时间线，建议同时保留反转节点，避免读者只看到单一阶段的结论。",
  },
];

export const testimonials = [
  {
    name: "周慕言",
    role: "长期读者 · 上海",
    text: "最实用的是时间线排版。以前在社交平台刷到一件事，前后信息混在一起根本理不清，这里一眼就能看出哪条是首发、哪条是反转。",
    rating: 5,
  },
  {
    name: "陈叙",
    role: "品牌公关从业者",
    text: "做公关最怕漏掉节点的先后顺序。我会把这里的时间线截图留档，复盘时对沟通节奏的判断很有参考价值。",
    rating: 5,
  },
  {
    name: "林知白",
    role: "消费维权志愿者",
    text: "投递过两条线索，都在两天内收到了核实反馈，其中一条被补进了时间线。处理方式比很多渠道都认真。",
    rating: 4,
  },
];

export const footerLinks = [
  { label: "首页", to: "/" },
  { label: "热点总览", to: "/events" },
  { label: "关于我们", to: "/about" },
];

export const workflowSteps = [
  {
    step: "01",
    title: "线索归集",
    desc: "接收读者投递的线索与当事方公开表述，按事件归类，不预先下结论。",
  },
  {
    step: "02",
    title: "时间校验",
    desc: "逐条确认信息的实际发生时间，避免因转发造成的时间错位。",
  },
  {
    step: "03",
    title: "交叉核对",
    desc: "关键节点至少比对两个独立来源，分歧之处原样保留并标注。",
  },
  {
    step: "04",
    title: "节点标注",
    desc: "判定属于首发、更新、反转还是后续，并写入同一条时间线。",
  },
];